export const ACTION_RESET = 'FETCH_EVENTDATABYID_RESET';
export const ACTION_REQUEST = 'FETCH_EVENTDATABYID_REQUEST';
export const ACTION_SUCCESS = 'FETCH_EVENTDATABYID_SUCCESS';
export const ACTION_ERROR = 'FETCH_EVENTDATABYID_ERROR';
